// Зеркало backend Application/Enums/CreateRoles.py — держим списки синхронно.
export const CREATE_ROLES = ['admin', 'Главный агроном'];
export const EDIT_ROLES = ['admin', 'Главный агроном'];
export const canCreateRecords = (role) => role !== null && CREATE_ROLES.includes(role);
export const canEditRecords = (role) => role !== null && EDIT_ROLES.includes(role);
export const NO_PERMISSION_TOOLTIP = 'Недостаточно прав — доступен только просмотр';
